 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HEROESALL_FRONTCOVER from '@/components/HeroesAll_frontcover'
 import HEROESALL_TITLE from '@/components/HeroesAll_title'
 import HEROESALL_COPYRIGHT from '@/components/HeroesAll_copyright'
 import HEROESALL_TOC from '@/components/HeroesAll_toc'
 import HEROESALL_FOREWARD from '@/components/HeroesAll_foreward'
 import HEROESALL_INTROANDACKNOWLEDGE from '@/components/HeroesAll_introandacknowledge'
 import HEROESALL_FM from '@/components/HeroesAll_fm'
 import HEROESALL_CHAPTER1 from '@/components/HeroesAll_Chapter1'
 import HEROESALL_CHAPTER101 from '@/components/HeroesAll_Chapter101'
 import HEROESALL_CHAPTER102 from '@/components/HeroesAll_Chapter102'
 import HEROESALL_CHAPTER103 from '@/components/HeroesAll_Chapter103'
 import HEROESALL_CHAPTER104 from '@/components/HeroesAll_Chapter104'
 import HEROESALL_CHAPTER105 from '@/components/HeroesAll_Chapter105'
 import HEROESALL_CHAPTER106 from '@/components/HeroesAll_Chapter106'
 import HEROESALL_CHAPTER107 from '@/components/HeroesAll_Chapter107'
 import HEROESALL_CHAPTER108 from '@/components/HeroesAll_Chapter108'
 import HEROESALL_CHAPTER109 from '@/components/HeroesAll_Chapter109'
 import HEROESALL_CHAPTER110 from '@/components/HeroesAll_Chapter110'
 import HEROESALL_CHAPTER2 from '@/components/HeroesAll_Chapter2'
 import HEROESALL_CHAPTER201 from '@/components/HeroesAll_Chapter201'
 import HEROESALL_CHAPTER202 from '@/components/HeroesAll_Chapter202'
 import HEROESALL_CHAPTER203 from '@/components/HeroesAll_Chapter203'
 import HEROESALL_CHAPTER204 from '@/components/HeroesAll_Chapter204'
 import HEROESALL_CHAPTER3 from '@/components/HeroesAll_Chapter3'
 import HEROESALL_CHAPTER301 from '@/components/HeroesAll_Chapter301'
 import HEROESALL_CHAPTER302 from '@/components/HeroesAll_Chapter302'
 import HEROESALL_CHAPTER303 from '@/components/HeroesAll_Chapter303'
 import HEROESALL_CHAPTER304 from '@/components/HeroesAll_Chapter304'
 import HEROESALL_CHAPTER4 from '@/components/HeroesAll_Chapter4'
 import HEROESALL_CHAPTER401 from '@/components/HeroesAll_Chapter401'
 import HEROESALL_CHAPTER402 from '@/components/HeroesAll_Chapter402'
 import HEROESALL_CHAPTER403 from '@/components/HeroesAll_Chapter403'
 import HEROESALL_CHAPTER404 from '@/components/HeroesAll_Chapter404'
 import HEROESALL_CHAPTER405 from '@/components/HeroesAll_Chapter405'
 import HEROESALL_CHAPTER406 from '@/components/HeroesAll_Chapter406'
 import HEROESALL_CHAPTER407 from '@/components/HeroesAll_Chapter407'
 import HEROESALL_CHAPTER408 from '@/components/HeroesAll_Chapter408'
 import HEROESALL_CHAPTER5 from '@/components/HeroesAll_Chapter5'
 import HEROESALL_CHAPTER6 from '@/components/HeroesAll_Chapter6'
 import HEROESALL_CHAPTER601 from '@/components/HeroesAll_Chapter601'
 import HEROESALL_CHAPTER602 from '@/components/HeroesAll_Chapter602'
 import HEROESALL_CHAPTER603 from '@/components/HeroesAll_Chapter603'
 import HEROESALL_CHAPTER604 from '@/components/HeroesAll_Chapter604'
 import HEROESALL_CHAPTER605 from '@/components/HeroesAll_Chapter605'
 import HEROESALL_CHAPTER606 from '@/components/HeroesAll_Chapter606'
 import HEROESALL_CHAPTER607 from '@/components/HeroesAll_Chapter607'
 import HEROESALL_CHAPTER608 from '@/components/HeroesAll_Chapter608'
 import HEROESALL_CHAPTER609 from '@/components/HeroesAll_Chapter609'
 import HEROESALL_CHAPTER610 from '@/components/HeroesAll_Chapter610'
 import HEROESALL_CHAPTER611 from '@/components/HeroesAll_Chapter611'
 import HEROESALL_CHAPTER612 from '@/components/HeroesAll_Chapter612'
 import HEROESALL_CHAPTER613 from '@/components/HeroesAll_Chapter613'
 import HEROESALL_CHAPTER614 from '@/components/HeroesAll_Chapter614'
 import HEROESALL_CHAPTER615 from '@/components/HeroesAll_Chapter615'
 import HEROESALL_CHAPTER616 from '@/components/HeroesAll_Chapter616'
 import HEROESALL_CHAPTER617 from '@/components/HeroesAll_Chapter617'
 import HEROESALL_CHAPTER618 from '@/components/HeroesAll_Chapter618'
 import HEROESALL_CHAPTER619 from '@/components/HeroesAll_Chapter619'
 import HEROESALL_CHAPTER620 from '@/components/HeroesAll_Chapter620'
 import HEROESALL_CHAPTER621 from '@/components/HeroesAll_Chapter621'
 import HEROESALL_CHAPTER622 from '@/components/HeroesAll_Chapter622'
 import HEROESALL_CHAPTER623 from '@/components/HeroesAll_Chapter623'
 import HEROESALL_CHAPTER624 from '@/components/HeroesAll_Chapter624'
 import HEROESALL_CHAPTER625 from '@/components/HeroesAll_Chapter625'
 import HEROESALL_CHAPTER626 from '@/components/HeroesAll_Chapter626'
 import HEROESALL_CHAPTER627 from '@/components/HeroesAll_Chapter627'
 import HEROESALL_CHAPTER628 from '@/components/HeroesAll_Chapter628'
 import HEROESALL_CHAPTER629 from '@/components/HeroesAll_Chapter629'
 import HEROESALL_CHAPTER630 from '@/components/HeroesAll_Chapter630'
 import HEROESALL_CHAPTER631 from '@/components/HeroesAll_Chapter631'
 import HEROESALL_CHAPTER632 from '@/components/HeroesAll_Chapter632'
 import HEROESALL_CHAPTER633 from '@/components/HeroesAll_Chapter633'
 import HEROESALL_CHAPTER634 from '@/components/HeroesAll_Chapter634'
 import HEROESALL_CHAPTER635 from '@/components/HeroesAll_Chapter635'
 import HEROESALL_CHAPTER636 from '@/components/HeroesAll_Chapter636'
 import HEROESALL_CHAPTER637 from '@/components/HeroesAll_Chapter637'
 import HEROESALL_CHAPTER638 from '@/components/HeroesAll_Chapter638'
 import HEROESALL_CHAPTER639 from '@/components/HeroesAll_Chapter639'
 import HEROESALL_CHAPTER640 from '@/components/HeroesAll_Chapter640'
 import HEROESALL_CHAPTER641 from '@/components/HeroesAll_Chapter641'
 import HEROESALL_CHAPTER642 from '@/components/HeroesAll_Chapter642'
 import HEROESALL_CHAPTER643 from '@/components/HeroesAll_Chapter643'
 import HEROESALL_CHAPTER644 from '@/components/HeroesAll_Chapter644'
 import HEROESALL_CHAPTER645 from '@/components/HeroesAll_Chapter645'
 import HEROESALL_CHAPTER646 from '@/components/HeroesAll_Chapter646'
 import HEROESALL_CHAPTER647 from '@/components/HeroesAll_Chapter647'
 import HEROESALL_CHAPTER648 from '@/components/HeroesAll_Chapter648'
 import HEROESALL_CHAPTER649 from '@/components/HeroesAll_Chapter649'
 import HEROESALL_CHAPTER650 from '@/components/HeroesAll_Chapter650'
 import HEROESALL_CHAPTER651 from '@/components/HeroesAll_Chapter651'
 import HEROESALL_CHAPTER652 from '@/components/HeroesAll_Chapter652'
 import HEROESALL_CHAPTER653 from '@/components/HeroesAll_Chapter653'
 import HEROESALL_CHAPTER654 from '@/components/HeroesAll_Chapter654'
 import HEROESALL_CHAPTER655 from '@/components/HeroesAll_Chapter655'
 import HEROESALL_CHAPTER656 from '@/components/HeroesAll_Chapter656'
 import HEROESALL_CHAPTER657 from '@/components/HeroesAll_Chapter657'
 import HEROESALL_CHAPTER658 from '@/components/HeroesAll_Chapter658'
 import HEROESALL_CHAPTER659 from '@/components/HeroesAll_Chapter659'
 import HEROESALL_CHAPTER660 from '@/components/HeroesAll_Chapter660'
 import HEROESALL_CHAPTER661 from '@/components/HeroesAll_Chapter661'
 import HEROESALL_CHAPTER662 from '@/components/HeroesAll_Chapter662'
 import HEROESALL_CHAPTER663 from '@/components/HeroesAll_Chapter663'
 import HEROESALL_CHAPTER664 from '@/components/HeroesAll_Chapter664'
 import HEROESALL_CHAPTER665 from '@/components/HeroesAll_Chapter665'
 import HEROESALL_CHAPTER666 from '@/components/HeroesAll_Chapter666'
 import HEROESALL_CHAPTER667 from '@/components/HeroesAll_Chapter667'
 import HEROESALL_CHAPTER668 from '@/components/HeroesAll_Chapter668'
 import HEROESALL_CHAPTER669 from '@/components/HeroesAll_Chapter669'
 import HEROESALL_CHAPTER670 from '@/components/HeroesAll_Chapter670'
 import HEROESALL_CHAPTER671 from '@/components/HeroesAll_Chapter671'
 import HEROESALL_CHAPTER672 from '@/components/HeroesAll_Chapter672'
 import HEROESALL_CHAPTER673 from '@/components/HeroesAll_Chapter673'
 import HEROESALL_CHAPTER674 from '@/components/HeroesAll_Chapter674'
 import HEROESALL_CHAPTER675 from '@/components/HeroesAll_Chapter675'
 import HEROESALL_CHAPTER7 from '@/components/HeroesAll_Chapter7'
 import HEROESALL_CHAPTER701 from '@/components/HeroesAll_Chapter701'
 import HEROESALL_CHAPTER702 from '@/components/HeroesAll_Chapter702'
 import HEROESALL_CHAPTER8 from '@/components/HeroesAll_Chapter8'
 import HEROESALL_CHAPTER9 from '@/components/HeroesAll_Chapter9'
 import HEROESALL_CHAPTER10 from '@/components/HeroesAll_Chapter10'
 import HEROESALL_CHAPTER1001 from '@/components/HeroesAll_Chapter1001'
 import HEROESALL_CHAPTER1002 from '@/components/HeroesAll_Chapter1002'
 import HEROESALL_CHAPTER11 from '@/components/HeroesAll_Chapter11'
 import HEROESALL_REFERENCES from '@/components/HeroesAll_references'
 import HEROESALL_ABBREVIATIONS from '@/components/HeroesAll_abbreviations'
 import HEROESALL_BIBLIOGRAPHY from '@/components/HeroesAll_bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/HeroesAll_frontcover",
 			"name" : "HeroesAll_frontcover",
 			"component" : HEROESALL_FRONTCOVER
 		},
 		{
 			"path" : "/HeroesAll_title",
 			"name" : "HeroesAll_title",
 			"component" : HEROESALL_TITLE
 		},
 		{
 			"path" : "/HeroesAll_copyright",
 			"name" : "HeroesAll_copyright",
 			"component" : HEROESALL_COPYRIGHT
 		},
 		{
 			"path" : "/HeroesAll_toc",
 			"name" : "HeroesAll_toc",
 			"component" : HEROESALL_TOC
 		},
 		{
 			"path" : "/HeroesAll_foreward",
 			"name" : "HeroesAll_foreward",
 			"component" : HEROESALL_FOREWARD
 		},
 		{
 			"path" : "/HeroesAll_introandacknowledge",
 			"name" : "HeroesAll_introandacknowledge",
 			"component" : HEROESALL_INTROANDACKNOWLEDGE
 		},
 		{
 			"path" : "/HeroesAll_fm",
 			"name" : "HeroesAll_fm",
 			"component" : HEROESALL_FM
 		},
 		{
 			"path" : "/HeroesAll_Chapter1",
 			"name" : "HeroesAll_Chapter1",
 			"component" : HEROESALL_CHAPTER1
 		},
 		{
 			"path" : "/HeroesAll_Chapter101",
 			"name" : "HeroesAll_Chapter101",
 			"component" : HEROESALL_CHAPTER101
 		},
 		{
 			"path" : "/HeroesAll_Chapter102",
 			"name" : "HeroesAll_Chapter102",
 			"component" : HEROESALL_CHAPTER102
 		},
 		{
 			"path" : "/HeroesAll_Chapter103",
 			"name" : "HeroesAll_Chapter103",
 			"component" : HEROESALL_CHAPTER103
 		},
 		{
 			"path" : "/HeroesAll_Chapter104",
 			"name" : "HeroesAll_Chapter104",
 			"component" : HEROESALL_CHAPTER104
 		},
 		{
 			"path" : "/HeroesAll_Chapter105",
 			"name" : "HeroesAll_Chapter105",
 			"component" : HEROESALL_CHAPTER105
 		},
 		{
 			"path" : "/HeroesAll_Chapter106",
 			"name" : "HeroesAll_Chapter106",
 			"component" : HEROESALL_CHAPTER106
 		},
 		{
 			"path" : "/HeroesAll_Chapter107",
 			"name" : "HeroesAll_Chapter107",
 			"component" : HEROESALL_CHAPTER107
 		},
 		{
 			"path" : "/HeroesAll_Chapter108",
 			"name" : "HeroesAll_Chapter108",
 			"component" : HEROESALL_CHAPTER108
 		},
 		{
 			"path" : "/HeroesAll_Chapter109",
 			"name" : "HeroesAll_Chapter109",
 			"component" : HEROESALL_CHAPTER109
 		},
 		{
 			"path" : "/HeroesAll_Chapter110",
 			"name" : "HeroesAll_Chapter110",
 			"component" : HEROESALL_CHAPTER110
 		},
 		{
 			"path" : "/HeroesAll_Chapter2",
 			"name" : "HeroesAll_Chapter2",
 			"component" : HEROESALL_CHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js